import { X } from 'lucide-react'
import type { PendingAttachment } from '../hooks/usePendingAttachments'

/** The pre-send photo strip above a chat composer: local preview thumbnails with
 *  per-item upload status (spinner / failed) and a remove button. */
export function ChatPendingThumbnails({
  pending,
  onRemove,
}: {
  pending: PendingAttachment[]
  onRemove: (localId: string) => void
}) {
  if (pending.length === 0) return null
  return (
    <div className="mb-2 flex flex-wrap gap-2">
      {pending.map(p => (
        <div key={p.localId} className="relative">
          <img
            src={p.previewUrl}
            alt=""
            className={`h-12 w-12 rounded-md border border-line object-cover ${
              p.status === 'failed' ? 'opacity-50' : ''
            }`}
          />
          {p.status === 'uploading' && (
            <div className="absolute inset-0 flex items-center justify-center rounded-md bg-black/40">
              <span className="h-4 w-4 animate-spin rounded-full border-2 border-paper/40 border-t-paper" />
            </div>
          )}
          {p.status === 'failed' && (
            <div className="text-miss absolute inset-0 flex items-center justify-center rounded-md bg-black/50 text-[9px] font-medium">
              Failed
            </div>
          )}
          <button
            type="button"
            aria-label="Remove photo"
            onClick={() => onRemove(p.localId)}
            className="absolute -top-1.5 -right-1.5 flex h-4 w-4 items-center justify-center rounded-full border border-line bg-bg text-paper-dim hover:text-paper"
          >
            <X size={10} />
          </button>
        </div>
      ))}
    </div>
  )
}
